import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { ITaskData } from "common/records/Task";

export const RECEIVE_TASK = "@tasks/RECEIVE_TASK";

export const TaskActions = {
  receiveTask: (task: Partial<ITaskData>) => createAction(RECEIVE_TASK, task),
};

export type TaskActions = ActionsUnion<typeof TaskActions>;
